define([
	"dojo/_base/declare",
	"csi",
	"csi/enums",
	"csi/heading/_base",
	"csi/state/rootStore",
	"csi/xml",
	"csi/xml/Query",
	"SiteAdmin/CopyForm",
	"Apparel/Theme/StyleThemeRenderer",
], function(declare, csi, enums, csiHeading, {featureTogglesStore}, xml, Query, CopyForm) {

	return declare(CopyForm, {
		/** @property {C8Node} sourceNode - The source node needs to be saved since the action controller m_urlNode changes to a new url for node copy, and would lose the original source node if copy is not successful. */
		sourceNode: null,

		/** @property {string} FIELD_COLORS - Id of the colorway field*/
		FIELD_COLORS: "ProductColors",

		isCopyingColorways: function() {
			// summary: return if Colorways checkbox is checked
			var options = this.defView.getFieldValue("_GeneralData");
			return options ? options.ProductColors : !!this.getViewNode().ProductColors.length;
		},

		/**
		 * @override
		 * Make Collection node as the context node
		 */
		getCopyContextURL: function() {
			// look for dest structure item.  if not available, default to parent season of orig style
			this.sourceNode = this.sourceNode || this.destStructureItem || this.defView.getSourceNode();
			return this.sourceNode.ParentSeason;
		},

		/**
		 * @override
		 * Populate the url of the action view make sure it can be able to query
		 */
		getFieldStore: function(field, value) {
			if (field.getControlName() == this.FIELD_COLORS) {
				const ctx = this.getContext();
				let store;

				csiHeading.applyHeadingRenderer(ctx, field.heading, function(renBase, hBase) {
					if (renBase && renBase.getStore) {
						store = renBase.getStore(ctx, hBase, value, true);
					}
				});

				// Since the action view doesn't have either path and url, need to populate the url with the source node
				// rather than the form node, otherwise, when open "Go to Dialog" view, wouldn't load anything
				store.action.m_viewRef.m_url = ctx.getNode().$URL;
				return store;
			} else if (field.getControlName() === "_RevisionBehavior") {
				// this is not an attribute of Style, but rather of CopyOptions, so aggregate store will not work;
				// for now just use data in reflection cache, but eventually will want to use server aggregate store, 
				// but cannot right now as there is not always a copy template(CopyOptions node)
				return enums.getStore(field.m_format);
			}

			return this.inherited(arguments);
		},

		/**
		* Disable the expression evaluation if the expression is already disabled on the source node
		* @override
		*/
		getValueForField: function(field, node) {
			var node = node || this.getFieldNode(field);
			var copyOptionsNode = this._copyOptionsNode;

			if (node && field.hasExpression() && (field.bDisableExpressionEvaluation === undefined) && !xml.isClientUrl(node.$URL) && copyOptionsNode && copyOptionsNode[field._idOption] != "") {
				var useSourceValue = copyOptionsNode && copyOptionsNode[field._idOption + "InitializedFromSource"];
				var copyOptionNotBlank = copyOptionsNode && xml.valueIsValid(copyOptionsNode[field._idOption], field.getType());
				var disabledExpression = !field.m_rca.isOneTimeExp && xml.nodeAttributeHasFlag(node, field.m_id, xml.ATTR_FLAG_DISABLE_EXPRESSION);
				var isDefault = field.isDefaultValue();

				field.bDisableExpressionEvaluation = useSourceValue || (copyOptionNotBlank && !isDefault) || disabledExpression;
			}

			return this.inherited(arguments);
		},

		_getCallMethod: function(/*Writer*/w) {
			return w.callMethod("Apparel", "StyleGetCopyOptions");
		},

		_getTemplateQuery: function() {
			// summary: setup query for copy options
			return new Query()
				.RefAttr("RootSubType", xml.OP_EQUALS, this.getViewNode().ProductType)
				.Node(xml.PROP_TYPE, xml.OP_EQUALS, "StyleType", "(StyleCopyOptions)Child:RootSubType(StyleType)")
				.Attr("Adhoc", xml.OP_EQUALS, false);

		},

		_getTemplateType: function() {
			// summary: return type of copy options
			return "StyleCopyOptions";
		},

		_resolveView: function() {
			this.addDefaultValue("CopiedFrom", this.getViewNode().$Name);
			this.inherited(arguments);

			// composite relationships should not be sent in aggregate store report
			const productColorsField = this.getField(this.FIELD_COLORS);
			if (productColorsField) {
				productColorsField.omitFromReport = true;
			}
		},

		/**
		 * Determine if Template needs to be selected for the Copy operation
		 * @return {bool}
		 */
		needToSelectTemplate: function() {
			const templateField = this.getField(this.FIELD_TEMPLATE);
			return this.isFieldVisible(templateField) && this.getFieldValue(templateField) == csi.EMPTY_URL;
		},

		/**
		 * Update Colorways field, based on GeneralData.ProductColors
		 * @override
		 */
		_buildField: function(ctx, field, tr, tdControl) {
			this.inherited(arguments);
			const colorwayField = this.getField(this.FIELD_COLORS);
			let isColorwaysDisabled = this.needToSelectTemplate();
			if (this._copyOptionsNode && field.m_id == "_GeneralData") {
				isColorwaysDisabled |= this._copyOptionsNode[field._idOption + "Locked"];
				if (!this.getFieldValue(field).ProductColors) {
					this.setFieldValue(colorwayField, []);
				} else {
					let values = [];
					_.each(this.getFieldStore(colorwayField)._store.data, function(item) {
						values.push(item.$);
					});
					this.setFieldValue(colorwayField, values);
				}
				this.setFieldDisabled(colorwayField, !!isColorwaysDisabled);
			}

		},

		/**
		 * Update Colorways field, based on Template setting
		 * @override
		 */
		onChangeTemplate: function(formView, field, value) {
			const colorwayField = this.getField(this.FIELD_COLORS);

			// Make Colorway field hidden if Template field is empty
			this.setFieldHidden(colorwayField, this.needToSelectTemplate());
			this.inherited(arguments);
		},

		/**
		 * Make template field visible if async style copy is on
		 * @override
		 */
		onSetDefaultValue: function(field, store, value) {
			this.inherited(arguments);
			if ((value == csi.EMPTY_URL) && (field.getControlName() == this.FIELD_TEMPLATE) && featureTogglesStore.ENABLE_ASYNC_STYLE_COPY) {
				if (store.isStoreEmpty()) {
					this.setFieldHidden(field, false);
				}
			}
		},
	});
});
